import clsx from 'clsx'

type CardHeaderProps = {
  imgSrc: string
  name: string
  description: string
  variant?: 'dark' | 'light'
}

export const CardHeader = ({
  imgSrc,
  name,
  description,
  variant = 'light',
}: CardHeaderProps) => {
  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between mb-3">
        <div className="w-16 h-16 bg-cw-purple-bright rounded-3xl flex items-center justify-center">
          <img
            src={imgSrc}
            alt={name}
            width={64}
            height={64}
            loading="lazy"
            sizes="64px"
          />
        </div>
      </div>

      <div>
        <h3
          className={clsx(
            'font-medium leading-tight font-funnel mb-1.5 text-[1.75rem]  text-cw-midnight-purple',
            {
              'text-white': variant === 'dark',
            },
          )}
          translate="no"
        >
          {name}
        </h3>
        <p
          className={clsx('text-card-description', {
            '!text-white': variant === 'dark',
          })}
        >
          {description || 'No description available'}
        </p>
      </div>
    </div>
  )
}
